import styled from 'styled-components';

export const DateRangeSelector = styled.div`
    position: relative;
`;

/**
 * Selector Styles
 */
export const Selector = styled.div`
    display: flex;
    height: 40px;
    border-radius: 40px;
    color: #ffffff;
    line-height: 40px;
    padding: 0 7px;
    transition: background-color 0.1s linear, box-shadow 0.3s linear;
    background-color: #ec4652;

    &:hover {
        box-shadow: 0 0 7px 2px rgba(25, 37, 45, 0.5);
        cursor: pointer;
    }

    &.selected {
        background-color: #00b357;
    }
`;

export const SelectorIcon = styled.div`
    font-size: 24px;
    display: inline-block;
    font-family: sans-serif;
    margin-right: 10px;
`;

export const SelectorSelected = styled.div`
    word-break: break-all;
    font-size: 14px;
    text-transform: uppercase;
    position: relative;
    top: 1px;
    overflow: hidden;
    letter-spacing: 0.8px;
`;

export const SelectorDropdownIndicator = styled.div`
    margin-left: auto;
    margin-right: 5px;
    width: 35px;
    text-align: right;
    &,
    > svg {
        font-size: 14px;
    }
`;

export const SelectorDropdownIndicatorReset = styled.div`
    display: inline-block;
    margin-right: 10px;
    opacity: 0.5;
    transition: opacity 0.1s linear;

    &:hover {
        opacity: 1;
    }
`;

export const Animated = styled.div`
    position: absolute;
    transition: 0.3s;
    z-index: 12;
    font-family: Montserrat, Helvetica, Verdana, Arial, sans-serif;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 6px, rgba(0, 0, 0, 0.07) 0px 0px 0px 1px;
    background: rgb(255, 255, 255);
    border-radius: 3px;
    overflow: hidden;
    width: 568px;
    @media (max-width: 640px) {
        width: 290px;
    }
`;
